import styled from 'styled-components'

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 10000;
`

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10001;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 800px) {
    align-items: flex-start;
    padding-top: 10vh;
  }
`

export const ModalWindow = styled.div`
  width: 742px;
  height: 370px;
  background: white;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 22px;
  position: absolute;

  @media (max-width: 800px) {
    flex-direction: column;
    width: 372px;
    height: auto;
    padding-bottom: 10px;
    margin-bottom: -12vh;
  }
`

export const ModalImage = styled.img`
  border-bottom-left-radius: 18px;
  border-top-left-radius: 18px;

  @media (max-width: 800px) {
    width: 100%;
    height: 296px;
    object-fit: cover;
    border-top-left-radius: 18px;
    border-top-right-radius: 18px;
    border-bottom-left-radius: 0;
  }
`

export const ModalContent = styled.div`
  text-align: center;
  max-width: 50%;
  box-sizing: border-box;
  margin-right: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  @media (max-width: 800px) {
    max-width: 90%;
    height: 100%;
  }
`

export const ModalTitle1 = styled.div`
  color: #262626;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 160%;

  & span {
    color: #ff5e6d;
  }

  @media (max-width: 800px) {
    font-size: 18px;
  }
`

export const ModalTitle = styled.div`
  font-weight: 700;
  font-size: 32px;
  line-height: 39px;
  color: #000000;
  padding-left: 10px;
  padding-right: 10px;

  @media (max-width: 800px) {
    font-size: 24px;
    line-height: 29px;
    width: 256px;
    margin-bottom: 14px;
  }
`

export const ModalDescription = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
  margin-top: 21px;
  margin-bottom: 31px;
  padding-left: 10px;
  padding-right: 10px;

  @media (max-width: 800px) {
    font-size: 14px;
    line-height: 20px;
    margin-top: 0;
    margin-bottom: 21px;
  }
`

export const ModalInputWrapper = styled.form`
  background: #f4f4f4;
  border-radius: 24px;
  box-sizing: border-box;
  width: 100%;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 800px) {
    background: white;
    flex-direction: column;
    height: auto;
  }
`

export const ModalInput = styled.input`
  background: transparent;
  border: none;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  padding-left: 25px;

  @media (max-width: 800px) {
    background: white;
    flex-direction: column;
    background: #f4f4f4;
    border-radius: 24px;
    text-align: center;
    width: 293px;
    height: 44px;
    margin-bottom: 9px;
    padding: 0;
  }
`

export const ModalInputButton = styled.button`
  background: #ff5e6d;
  border-radius: 37px;
  color: #ffffff;
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
  border: none;
  width: 118px;
  height: 37px;
  margin-right: 5px;

  @media (max-width: 800px) {
    width: 293px;
    height: 44px;
    margin: 0;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
  }
`

export const ModalCloseButton = styled.button`
  background: transparent;
  border: none;
  position: absolute;
  top: -25px;
  opacity: 0.5;

  @media (max-width: 800px) {
    left: 0px;
  }
`

export const Button = styled.a`
  border-radius: 37px;
  background: #ff5e6d;
  width: 100%;
  padding: 12px 0;
  color: #fff;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 35px;

  @media (max-width: 800px) {
    margin-top: 0px;
    margin-bottom: 10px;
  }
`

export const ListDesktop = styled.ul`
  color: #262626;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  display: block;

  @media (max-width: 800px) {
    font-size: 16px;
    display: none;
  }
`

export const ListMobile = styled.ul`
  color: #262626;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  display: none;

  @media (max-width: 800px) {
    font-size: 16px;
    display: block;
    margin-top: 8px;
  }
`

export const TryNowLine = styled.div`
  display: flex;
  align-items: center;
  margin-top: 48px;

  & p {
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    color: #000000;

    @media (max-width: 800px) {
      text-align: left;
      margin: 0;
      padding: 0;
    }
  }

  @media (max-width: 800px) {
    padding-left: 10px;
    padding-right: 10px;
    margin-top: 21px;
  }
`

export const TryNowButton = styled.a`
  width: 75px;
  height: 28px;
  border: 1px solid #ff5e6d;
  border-radius: 37px;
  color: #ff5e6d;
  font-weight: 700;
  font-size: 11px;
  line-height: 13px;
  margin-left: 7px;
  display: flex;
  justify-content: center;
  align-items: center;

  & span {
    margin-bottom: -3px;
  }
`
